// extracted by mini-css-extract-plugin
module.exports = {"rotation":"SoluzioniTemplate_rotation__4XXvn"};